import { CSSProperties } from 'react';
import { css, styled } from 'styled-components';

export const TextAreaContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TextAreaLabel = styled.label<{
  $transitionTime?: number;
  $hasError?: boolean;
  color?: CSSProperties['color'];
}>`
  ${({ $hasError = false, $transitionTime = 200, color = 'black' }) => css`
    font-size: 17px;
    font-style: normal;
    color: ${$hasError ? 'red' : color};
    transition: color ${$transitionTime * 2}ms;
  `}
`;

export const Message = styled.p<{
  $transitionTime?: number;
  $hasError?: boolean;
}>`
  ${({ $hasError = false, $transitionTime = 200 }) => css`
    transition: color ${$transitionTime * 2}ms;
    color: ${$hasError ? 'red' : 'transparent'};
    min-height: 18.4px;
    text-align: start;
    margin: 10px 0;
  `}
`;

export const TextArea = styled.textarea<{
  color?: CSSProperties['color'];
}>`
  ${({ color = 'black' }) => css`
    border-radius: 5px;
    border: none;
    color: ${color};
    outline: none;
    font-size: 17px;
    padding: 10px;
    background: #d9d9d9;
  `}
`;
